export const UPCOMING_DISPATCHES_QUERY = `
query UpcomingDispatchesQuery {
  upcomingDispatches {
    event_nodes {
	  event_node_id
	  event_node_start_dttm_utc
    event_node_end_dttm_utc
      organization_name {
        label
        locale
      }
      site_display_label {
        label
        locale
      }
    }
    program_name {
      label
      locale
    }
    portfolio_name {
      label
      locale
    }
	full_time_zone
  }
}
`